<template>
  <q-page class="main">
    <div class="row justify-center items-center" :class="{'q-pa-md': !$isDesktop }">
      <q-card class="col-12 col-md-8">
        <common-form :action="$route('user_management.store-approval')">
        <q-card-section :class="$isDesktop ? 'q-pa-xl' : 'q-pa-lg'">
          <h1 class="heading-2 q-mb-lg">Privacy statement</h1>
          <div v-html="statement"></div>
        </q-card-section>
        <q-separator v-if="needsToApprove"/>
        <q-card-actions v-if="needsToApprove" align="between" :class="$isDesktop ? 'q-pa-xl' : 'q-pa-lg'">
            <flat-button :label="disagree" @click="$goto('auth.logout')" />
            <accent-button :label="agree" type="submit" />
        </q-card-actions>
        </common-form>
      </q-card>
    </div>
  </q-page>
</template>

<script>
export default {
  props: {
    needsToApprove: {
      type: Boolean
    },
    statement: {
      type: String
    }
  },
  computed:{
    disagree() {
      if(this.$isDesktop){
        return 'Ik ga niet akkoord met deze voorwaarden'
      }

      return 'Niet akkoord'
    },
    agree() {
      if(this.$isDesktop){
        return 'Ik ga akkoord met deze voorwaarden'
      }

      return 'Akkoord'
    }
  }
}
</script>
